<template>
  <main class="interview">
    <img class="close_icon" src="@/assets/close.svg" v-on:click="onClose()" />
    <div class="interview_contents">
      <div class="interview_contents__left">
        <div class="qa qa--top">
          <div class="qa__question">
            <div class="qa__question_icon qa__question_icon--active">Q1</div>
            <div class="qa__question_title" v-on:click="pager.toggleDebug()">
              最もやりたいことを教えてください
            </div>
          </div>
          <div class="qa__answer">
            <div class="qa__answer_icon" v-if="false">A1</div>
            <div class="qa__answer_title qa__answer_title--active">回答中</div>
          </div>
        </div>
      </div>
      <div class="interview_contents__main">
        <div class="interview_header">
          <div class="interview_header__progress">
            <div class="interview_header__no">
              <div class="interview_header__no_title">
                <img class="interview_header__no_title_icon" src="@/assets/format_list_bulleted.svg" width="24" />回答
              </div>
              <div class="interview_header__no_num">Q1</div>
            </div>
            <div class="interview_header__progress_bar"></div>
          </div>
          <div class="interview_header__title">
            最もやりたいことを教えてください
          </div>
        </div>
        <div class="interview_body">
          <div class="freewordinput">
            <input class="freewordinput__input" placeholder="やりたいことを一つ入力してください" v-model="page.userinput" type="text" />
            <img style="position: absolute; top: 8px; left: 16px" src="@/assets/search.svg" />
            <img v-on:click="clean()" style="position: absolute; top: 8px; right: 12px; cursor: pointer"
              src="@/assets/close.svg" />
          </div>
          <div class="freeword_interview_expectations__title" v-if="page.userinput.length == 0">
            よく入力される言葉
          </div>
          <div class="freewordinput__recommend" v-if="page.userinput.length == 0">
            <template v-for="(item, index) in recwords" :key="index">
              <button class="interview_control__recommend btn_outline_primary" v-on:click="selectword(item)">
                {{ item }}
              </button>

            </template>

          </div>
          <div class="freeword_interview_expectations__title" v-if="page.userinput.length > 0">
            「{{ page.userinput }}」の検索結果
          </div>
          <div v-show="isloading">
            <div id="lottie"></div>
          </div>

          <div class="start_interview_expectations__candidates start_interview_expectations__candidates--lp"
            v-if="page.userinput.length > 0">
            <template v-for="(item, index) in page.expectations" :key="index">
              <button class="qasinglebtn" v-on:click="page.select(item.id)" :class="[
                  isSelected(item.id) ? 'qasinglebtn--selected' : '',
                  index == 0 ? 'qasinglebtn--first' : '',
                ]">
                <div>
                  {{ item.title }}
                </div>
              </button>
            </template>
          </div>

          <div class="freewor_example" v-if="page.userinput.length == 0">
            <div class="freewor_example__title">入力例</div>
            <div class="freewor_example__exp">
              <img class="freewor_example__icon" src="@/assets/ellipse18stroke.svg" />
              <div class="freewor_example__text">ウェブサイトを作る</div>
            </div>
            <div class="freewor_example__exp">
              <img class="freewor_example__icon" src="@/assets/union.svg" />
              <div class="freewor_example__text">来年入社する新卒社員の採用にあたり、採用広報のサイトを制作して～</div>
            </div>

          </div>
        </div>
        <div class="interview_control">
          <button class="interview_control__back btn_outline_primary btn_outline_primary--disabled" v-if="false">
            前の質問に戻る
          </button>
          <button class="interview_control__next btn_primary" :class="[!page.isSelected() ? 'btn_primary--disabled' : '']"
            v-on:click="startInterview()">
            次へ
          </button>
        </div>
      </div>
      <div class="interview_contents__right"></div>
    </div>

    <div style="margin-bottom: 32px; background: rgb(239, 240, 240)" v-if="pager.isDebug">
      <div>デバグ</div>
      <div>{{ page.debug }}</div>
      <div>入力値</div>
      <div>{{ page.userinput }}</div>
    </div>
  </main>
</template>

<style scoped>
.freewordinput__recommend {
  margin-bottom: 8px;
}

.interview_control__recommend {
  margin-bottom: 8px;
  margin-right: 8px;
}

.freewor_example__title {
  font-size: 13px;
  font-weight: bold;
  line-height: 136%;
}

.freewor_example {
  background: rgb(254, 238, 187);
  border-radius: 4px;
  padding: 8px 12px;
}

.freewor_example__icon {
  margin-top: 2px;
}

.freewor_example__exp {
  display: flex;
  padding: 4px 0;
}

.freewor_example__text {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 132%;
}
</style>

<style scoped>
.freewordinput {
  position: relative;
}

.freewordinput__input {
  padding-left: 48px;
  width: calc(100% - 52px);
  font-size: 14px;
  line-height: 142%;
  border-radius: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.freewordinput__input:focus {
  border: solid 2px #00c9c9;
  outline: none;
}

.freeword_interview_expectations__title {
  margin-top: 16px;
  font-size: 13px;
  font-weight: bold;
  line-height: 136%;
  margin-bottom: 8px;
}
</style>

<style scoped>
.lpbtn {
  background: #f9fbfb;
  color: #444545;
  padding: 18px 18px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  cursor: pointer;
}

.lpbtn:hover {
  border: 2px solid #00c9c9;
}

.lpbtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.lpbtn__description {
  font-size: 12px;
  line-height: 126%;
  font-weight: initial;
  min-height: 16px;
}

.qasinglebtn {
  background: #f9fbfb;
  color: #444545;
  padding: 12px 12px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  width: 100%;
  /* max-width: 600px; */
  text-align: left;
  cursor: pointer;
}

.qasinglebtn--first {
  margin-top: 0px;
}

.qasinglebtn:hover {
  border: 2px solid #00c9c9;
}

.qasinglebtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}
</style>

<style scoped>
#lottie {
  margin: auto;
  width: 150px;
}
</style>

<script>
// @ is an alias to /src

/* global bodymovin */

import tacklebox from "tacklebox";

import { FreewordPage } from "@/js/page/FreewordPage.js";

tacklebox.d("a");

export default {
  name: "FreewordView",
  data() {
    return {
      page: new FreewordPage(),
      isNetworking: false,
      userinput: "",
      inputtimer: null,
      isloading: false,
      recwords: [
        "Webサイト",
        "経費精算",
        "Web会議",
        "データ分析",
        "名刺管理",
      ]
    };
  },
  watch: {
    // eslint-disable-next-line
    "page.userinput": function (oldv, newv) {
      const self = this;
      this.page.cancel();
      this.isloading = true;
      if (this.inputtimer) {
        clearTimeout(this.inputtimer);
      }

      this.inputtimer = setTimeout(function () {
        self.isloading = false;
        self.page.search();
      }, 300 * 2);
    },
  },
  mounted() {
    this.page.interviewId = this.$route.params.id;
    this.pager.changePage(this.page);
    bodymovin.loadAnimation({
      container: document.getElementById("lottie"),
      renderer: "svg", // 描画形式
      loop: true, // trueにしたらループ。1回再生の場合はfalse
      autoplay: true, // 自動再生
      path: "freeloading.json", // jsonのパスを指定
      name: "Hello World", // 今後のリファレンスとして名前を指定（オプション）
    });

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeUnmount() {
    //
  },
  methods: {
    selectword(word) {
      this.page.userinput = word;
    },
    clean() {
      this.page.userinput = "";
    },
    isSelected(id) {
      for (let i in this.page.selecteds) {
        if (this.page.selecteds[i] == id) {
          return true;
        }
      }
      return false;
    },
    startInterview() {
      const self = this;
      if (!this.page.isSelected()) {
        return;
      }
      this.isNetworking = true;
      this.page.startInterview(function (interview_id) {
        if (interview_id) {
          self.$router.push({
            name: "expectation",
            params: { id: interview_id },
          });
        } else {
          self.isNetworking = false;
        }
      });
    },
    back() {
      this.$router.push("/");
    },
    onClose() {
      this.$router.push("/");
    },
  },
  components: {},
  props: {
    pager: Object,
  },
};
</script>
